import React from 'react';
import { useReveal } from '../hooks/useReveal';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  className?: string;
};
export function Reveal({
  children,
  delay = 0,
  className = ''
}: RevealProps) {
  const ref = useReveal<HTMLDivElement>();
  return <div ref={ref} className={`reveal ${className}`} style={{
    transitionDelay: `${delay}ms`
  }} data-id="element-102" data-mp="3ggph22y07c8e">
      {children}
    </div>;
}